import React from "react";

const ResetFiltersButton = ({ onReset }) => {
  return (
    <button
      className="bg-red-500 text-white px-4 py-2 rounded"
      onClick={onReset}
      data-posthog="filters-reset"
    >
      Clear Filters
    </button>
  );
};

export default ResetFiltersButton;
